import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import PortfolioDetailsV2 from "StudentPortfolio/routes/PortfolioDetailsV2";
export default store => {
  return {
    path: "student-profile",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "student-profile-v2" */ "./components"),
          import(
            /* webpackChunkName: "student-profile-v2" */ "./modules/ProfileModule"
          ),
          import(
            /* webpackChunkName: "student-profile-v2" */ "StudentPortfolio/modules/StudentPortfolioModule"
          ),
          import(
            /* webpackChunkName: "student-profile-v2" */ "../Profile/modules/ProfileModule"
          ),
        ]).then(
          ([
            importedModule0,
            importedModule1,
            importedModule2,
            importedModule3,
          ]) => {
            const component = importedModule0.default;
            const reducer = importedModule1.default;
            const studentPortfolioReducer = importedModule2.default;
            const platformProfileV1 = importedModule3.default;
            injectReducer(store, {
              key: "platformProfileV2",
              reducer,
            });
            injectReducer(store, {
              key: "studentPortfolio",
              reducer: studentPortfolioReducer,
            });
            injectReducer(store, {
              key: "platformProfile",
              reducer: platformProfileV1,
            });
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [PortfolioDetailsV2(store)],
  };
};
